import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { createdImagesActions } from '../../actions';
import {
  LoadMoreStudioImagesActionPayload,
  PushMoreStudioImagesActionPayload,
} from '../../typedefs';

export function* loadMoreStudioImages({
  payload,
}: PayloadAction<LoadMoreStudioImagesActionPayload>) {
  try {
    yield effects.put(createdImagesActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: payload.url, direct: true },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }

    const data: PushMoreStudioImagesActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(createdImagesActions.pushMoreStudioImages(data));
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(createdImagesActions.stopFetching());
  }
}
